import { gsap } from 'gsap'

const headlineWords = document.querySelectorAll('.headline-word')
const hasMultipleWords = headlineWords.length > 1

if (headlineWords.length) {
  const timeline = gsap.timeline({
    repeat: hasMultipleWords ? -1 : 0,
  })

  headlineWords.forEach((el) => {
    const keyframes = [
      { y: '10%', opacity: 0, duration: 0 },
      { y: '0', opacity: 1, duration: 0.5, ease: 'ease' },
    ]

    if (hasMultipleWords) {
      keyframes.push({
        y: '-10%',
        opacity: 0,
        duration: 0.5,
        delay: 1,
        ease: 'ease',
      })
    }

    timeline.add(
      gsap.to(el, {
        keyframes,
      })
    )
  })
}
